
import React from 'react';
import FooterSection from './FooterSection';
import FooterLink from './FooterLink';

const FooterLinks = () => {
  return (
    <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
      <FooterSection title="Comparer">
        <FooterLink href="/comparaison/hootsuite" isRouterLink={true}>
          Scaloo vs. Hootsuite
        </FooterLink>
        <FooterLink href="#">
          Scaloo vs. Sprout
        </FooterLink>
        <FooterLink href="#">
          Scaloo vs. Swello
        </FooterLink>
        <FooterLink href="#">
          Scaloo vs. Buffer
        </FooterLink>
      </FooterSection>

      <FooterSection title="Fonctionnalités">
        <FooterLink href="#">
          Inbox Social Media
        </FooterLink>
        <FooterLink href="#">
          Publication
        </FooterLink>
        <FooterLink href="#">
          Veille
        </FooterLink>
        <FooterLink href="#">
          Reporting
        </FooterLink>
        <FooterLink href="#">
          Social Media ROI
        </FooterLink>
        <FooterLink href="#">
          Pour les Agences
        </FooterLink>
      </FooterSection>

      <FooterSection title="Entreprise">
        <FooterLink href="#">
          Contactez-nous
        </FooterLink>
        <FooterLink href="#">
          Nos Clients
        </FooterLink>
        <FooterLink href="#">
          Rejoignez-nous
        </FooterLink>
        <FooterLink href="#">
          Presse
        </FooterLink>
      </FooterSection>

      <FooterSection title="Aide">
        <FooterLink href="#">
          Bien démarrer
        </FooterLink>
        <FooterLink href="#">
          Aide & Support
        </FooterLink>
        <FooterLink href="#">
          État de la Plateforme
        </FooterLink>
      </FooterSection>
    </div>
  );
};

export default FooterLinks;
